/**
 * Depending on count, return the singular or plural
 */
function pluralize(count: number, singular: string, plural: string): string {
  return (count === 1) ? `${count} ${singular}` : `${count} ${plural}`;
}

export {pluralize};
